
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/heineken_template",
      function () {
        return require("private-next-pages/heineken_template/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/heineken_template"])
      });
    }
  